import M2hLocaleChanger from "@/page-elements/M2hLocaleChanger";
import M2hLoader from "@/page-elements/M2hLoader";
import M2hBestChoices from "@/page-elements/M2hBestChoices.vue";
import M2hContinueJourney from "@/page-elements/M2hContinueJourney.vue";
import M2hNewsFeed from "@/page-elements/M2hNewsFeed.vue";
import M2hDailyInspiration from "@/page-elements/M2hDailyInspiration.vue";
import M2hUpcomingEvents from "@/page-elements/M2hUpcomingEvents.vue";
import M2hAccountSetup from "@/page-elements/M2hAccountSetup.vue";
import M2hSeries from "@/page-elements/M2hSeries.vue";
import M2hAnalytics from "@/page-elements/M2hAnalytics.vue";
import M2hSpotlight from "@/page-elements/M2hSpotlight.vue";
import M2hUnboxChallengeWidgetOne from "@/page-elements/widgets/challenges/M2hUnboxChallengeWidgetOne.vue";
import M2hConsentDialog from "@/page-elements/M2hConsentDialog.vue";
import M2hSnackbar from "@/page-elements/M2hSnackbar.vue";
import M2hBioAgeWidget from "@/page-elements/widgets/wefitter/M2hBioAgeWidget.vue";
import M2hVideoPlayer from "@/page-elements/M2hVideoPlayer.vue";
import M2hWeFitterChallengeWidget from "@/page-elements/widgets/challenges/M2hWeFitterChallengeWidget.vue";
import MTHBioAgeWidget from "@/page-elements/widgets/wefitter/MTHBioAgeWidget.vue";
const M2hPagePlugin = {
  install(Vue) {
    Vue.component(M2hLoader.name, M2hLoader)
    Vue.component(M2hLocaleChanger.name, M2hLocaleChanger)
    Vue.component(M2hBestChoices.name, M2hBestChoices)
    Vue.component(M2hContinueJourney.name, M2hContinueJourney)
    Vue.component(M2hNewsFeed.name, M2hNewsFeed)
    Vue.component(M2hDailyInspiration.name, M2hDailyInspiration)
    Vue.component(M2hUpcomingEvents.name, M2hUpcomingEvents)
    Vue.component(M2hAccountSetup.name, M2hAccountSetup)
    Vue.component(M2hSeries.name, M2hSeries)
    Vue.component(M2hAnalytics.name, M2hAnalytics)
    Vue.component(M2hSpotlight.name, M2hSpotlight)
    Vue.component(M2hUnboxChallengeWidgetOne.name, M2hUnboxChallengeWidgetOne)
    Vue.component(M2hConsentDialog.name, M2hConsentDialog)
    Vue.component(M2hSnackbar.name, M2hSnackbar)
    Vue.component(M2hBioAgeWidget.name, M2hBioAgeWidget)
    Vue.component(M2hVideoPlayer.name, M2hVideoPlayer)
    Vue.component(M2hWeFitterChallengeWidget.name, M2hWeFitterChallengeWidget)
    
    Vue.component(MTHBioAgeWidget.name, MTHBioAgeWidget)
  }
}

export { M2hPagePlugin }
